export const environment = {
    production: false,
    apim_subscription:"#{apim_subscription}#",
    url_ame: "#{url_ame}#",
    url_waf: "#{url_apim}#",
};